import { Button } from '@/components/ui/button';
import { OnboardingSlide } from '../../../hooks/useOnboarding';
import { ChevLeftFilledIcon, ChevRightFilledIcon } from '@/components/Icons';
import { cn } from '@/utils';
import { Button as PrimaryButton } from '@jenmusic/jen-ui-library';

interface SlideProps extends OnboardingSlide {
  onNext?: () => void;
  onPrevious?: () => void;
}

export function Slide({ title, description, image, buttons, cardContent, currentSlide, totalSlides, onNext, onPrevious }: SlideProps) {
  return (
    <div className="grid min-h-[480px] w-full grid-cols-1  lg:grid-cols-2">
      <div className="flex flex-col justify-between pl-12 pt-12 pb-12 pr-9">
        <div className="space-y-6 w-[266px]">
          <h1 className=" typography-jenmusic-display-small tracking-[-2px]">{title}</h1>
          <p className="text-xl text-gray-500 tracking-[-0.8px] leading-[120%]">{description}</p>
        </div>
        <div className="flex items-center gap-4 justify-between h-9">
          {currentSlide === totalSlides ? (
            <PrimaryButton className=" h-[36px] rounded-[4px]" onClick={onNext}>
              Make music now
            </PrimaryButton>
          ) : (
            <div className="text-[0.8rem] text-[#9d9da6]">
              {currentSlide}/{totalSlides}
            </div>
          )}

          <div className="flex gap-2">
            <div
              className={cn(
                'w-6 h-6 flex justify-center items-center bg-jenmusic-interactive hover:opacity-80 rounded-full cursor-pointer',
                {
                  '!opacity-20 cursor-not-allowed': currentSlide === 1,
                },
              )}
              onClick={() => {
                currentSlide !== 1 && onPrevious?.();
              }}
            >
              <ChevLeftFilledIcon fillColor="#fff" className="w-4 h-4 rounded-full bg-jenmusic-interactive" />
            </div>
            <div
              className={cn(
                'w-6 h-6 flex justify-center items-center bg-jenmusic-interactive hover:opacity-80 rounded-full cursor-pointer',
                {
                  '!opacity-20 cursor-not-allowed': currentSlide === totalSlides,
                },
              )}
              onClick={() => {
                currentSlide !== totalSlides && onNext?.();
              }}
            >
              <ChevRightFilledIcon fillColor="#fff" className="w-4 h-4 rounded-full bg-jenmusic-interactive" />
            </div>
          </div>
        </div>
      </div>
      <div
        className="flex items-center justify-center bg-[#F4F4F4]"
        style={{
          background: `url(${image})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        {/* {cardContent ? cardContent : image && <img src={image} alt="" className="max-h-[500px] w-auto" />} */}
      </div>
    </div>
  );
}
